import { VideoCardProps } from 'ui/components/2-molecules/Card/VideoCard/VideoCard';
import dynamic from 'next/dynamic';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

/**
 * React Player is a large dependency used only on a few select pages
 * so we opt to load it dynamically with next/dynamic
 */
const DynamicVideoCard = dynamic<VideoCardProps>(
	() => import('ui/components/2-molecules/Card/VideoCard/VideoCard').then((module) => module.UI_VideoCard),
	{
		ssr: false,
	},
);

export const VideoCard = ({ content }: Content.VideoCard) => {
	const dictionary = useDictionaryContext();

	return <DynamicVideoCard {...content} playVideoText={dictionary.getAction('PlayVideo')} />;
};
